import { render, staticRenderFns } from "./EditPodcast.vue?vue&type=template&id=0008d4d6&"
import script from "./EditPodcast.vue?vue&type=script&lang=js&"
export * from "./EditPodcast.vue?vue&type=script&lang=js&"
import style0 from "./EditPodcast.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports